"use client";
import { BlogServices } from "@/services";
import { useParams, useRouter } from "next/navigation";

function useSimilarBlog() {
  const params = useParams();
  const slug = params.slug as string;
  const router = useRouter();

  const { data: singleBlog } = BlogServices().useGetSingleBlog(slug);

  // SIMILAR BLOGS
  const { data: similarBlogs } = BlogServices().useGetSimilarBlogs(
    singleBlog?.category,
    slug,
  );
  return {
    similarBlogs,
    router,
  };
}

export default useSimilarBlog;
